export default __webpack_public_path__ + "images/icons/arrow-bottom-selected-d68652d9fbc20597c03d4f0c3455f0e9.svg";